import {ConfigProvider, List} from "antd";
import moment from "moment";
import React from "react";
import {AppStore} from "../useAppPullState";

const data = [
    {
        title: "Ant Design Title 1",
    },
    {
        title: "Ant Design Title 2",
    },
    {
        title: "Ant Design Title 3",
    },
    {
        title: "Ant Design Title 4",
    },
];
export default () => {
    const todayBookings = AppStore.useState(s => s.userTodayBookings);
    // // only today's bookings
    // const todayBookings = userBookings?.filter((item) => {
    //     //05/09/2023 to date
    //     const bookingDate = moment(item.date, "DD/MM/YYYY").format("YYYY-MM-DD");
    //     return moment(bookingDate).isSame(moment(), "day");
    // });

    // console.log('[[PreviousHistory]] todayBookings', {todayBookings})

    return (
        <>
            {!!todayBookings ? (
                <ConfigProvider renderEmpty={() => "Ei varauksia"}>
                    <List
                        itemLayout='horizontal'
                        dataSource={todayBookings || []}
                        renderItem={(item, index) => {
                            // console.log('[[PreviousHistory]]', {item});
                            return (
                                <List.Item key={index}>
                                    <List.Item.Meta
                                        title={
                                            <div style={{fontStyle: "bold"}}>
                                                <span style={{paddingLeft: 5}}>{item.courseName}</span>
                                            </div>
                                        }
                                        description={
                                            <div style={{fontStyle: "bold"}}>
                                                <span style={{paddingLeft: 5}}>{item.date}</span>
                                            </div>
                                        }
                                    />
                                </List.Item>
                            )
                        }}
                    />
                </ConfigProvider>
            ) : (
                <></>
            )}
        </>
    );
};
